import { apiCall } from "./service";
import {
  URL_PORTFOLIO,
  URL_CLIENT,
  URL_CLIENT_PROGRAMS,
  URL_PROGRAM,
  URL_CREATE_PROGRAMS,
  URL_UPDATE_PROGRAMS,
  URL_DELETE_PROGRAMS,
  URL_PROGRAM_DETAILS,
  URL_PROGRAM_FLAG,
  URL_PROGRAM_PROGRESS_TRACKER,
  BASE_URL,
  URL_PROJECTS,
} from "./URL";

export const api = {
  getProgramsRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {
      case "Client":
        url = `${BASE_URL}Clients/${id}/Programs`;
        break;

      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Programs`;
        break;

      case "Program":
        url = `${BASE_URL}Programs/${id}/Programs`;
        break;

      default:
        url = `${BASE_URL}Programs`;
    }

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },
  fetchProgramDataRequest(params) {
    return apiCall.get({ url: `${URL_PROGRAM}${params.id}` });
  },
  sortProgramsRequest(params) {
    if (params.parent === "Client")
      return apiCall.pagination({
        url: `${URL_CLIENT_PROGRAMS}?pageNumber=${params.page}&pageSize=${params.size}&clientId=${params.id}&orderby=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_CLIENT_PROGRAMS}?pageNumber=${params.page}&pageSize=${params.size}&portfolioId=${params.id}&orderby=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_CLIENT_PROGRAMS}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
        isAuthToken: true,
      });
  },
  createProgramsRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_PROGRAMS}`,
      params: params.payload,
    });
  },
  updateProgramsRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_PROGRAMS}${params.id}`,
      params: params.payload,
    });
  },
  deleteProgramsRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_PROGRAMS}${params}` });
  },
  getProgramDetailsRequest(params) {
    if (params.id) {
      return apiCall.get({ url: `${URL_PROGRAM_DETAILS}${params.id}` });
    }
  },
  updateProgramFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_PROGRAM_FLAG}${params.id}`,
      params: params.payload,
    });
  },
  fetchProgramBudgets: async (programId) => {
    try {
      const response = await apiCall.get({
        url: `${URL_PROGRAM}${programId}/Budgets`,
        isAuthToken: true,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  ///////////////////// Health Status ////////////////////////

  getProgressTracker(id) {
    return apiCall.get({ url: URL_PROGRAM_PROGRESS_TRACKER(id) });
  },

  updateProgressKPI(params) {
    return apiCall.put({
      url: URL_PROGRAM_PROGRESS_TRACKER(params.id),
      params: params.payload,
    });
  },

  getStatusReport(params) {
    let url = `${URL_PROGRAM}${params.id}/WSR`;

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var paylaod = { tz: timezone };

    if (params.date)
      paylaod.date = params.date;

    if (params.options)
      paylaod.options = params.options;

    return apiCall.pdfPost({ url: url, params: paylaod });
  },

  filterProgressTracker(params) {
    return apiCall.get({
      url: `${URL_PROGRAM_PROGRESS_TRACKER(params.id)}?date=${params.data.date}`,
    });
  },
  getProgramBudgetSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PROGRAM}${params.id}/budget-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  getProgramProgressSummaryRequest(params) {
    if (params.id) {
      return apiCall.get({
        url: `${URL_PROGRAM}${params.id}/progress-summary`,
        isAuthToken: true,
        params,
      });
    }
  },
  getTeam(id) { 
    return apiCall.get({url: `${URL_PROGRAM}${id}/Detailed-Resources`});
  },
};

export default api;
